import React, { useContext } from 'react';

import { ATTACHMENTS } from 'newJs/config';
import { AttachsParamsContext } from 'providers/attachs-params';
import { AttachsStateContext } from 'providers/attachs-state';
import { default as HeaderAction } from 'containers/Attachments/Item/Action';
import { FaIcon, IoIcon } from 'components/Icons';
import AttachDataProvider from 'providers/attachs-data';
import InxToolTip from 'containers/Attachments/ToolTip';

const {
        CLICK_ACTIONS: {
            DOWNLOAD,
            SAVE_TO_FILES,
            SAVE_TO_FOTO,
            VIEW_AS_GRID,
        },
        VIEW_MODE
    } = ATTACHMENTS,
    defaultButtons = (rotateFunc, i18n) => [
        { action: DOWNLOAD, icon: <IoIcon name='IoMdDownload' /> },
        <>
            <span
                className='item-action'
                data-tip={i18n}
                key='rotate-right'
                onClick={() => rotateFunc('right')}
                data-for='ril__ttip-img-rotate'
            >
                <FaIcon name='FaRedo' size='0.65em' />
            </span>
            <InxToolTip className='ril__tooltip' id='ril__ttip-img-rotate' />
        </>
    ];

const withItemData = (itemData, arr) => arr.map((item, idx) => {
    return React.isValidElement(item)
        ? item
        : <AttachDataProvider key={idx} value={itemData}>
            <HeaderAction
                actionName={item.action}
                className='ril__builtinButton'
                toolTipSelector={`ril__ttip${idx}`}
            >
                {item.icon}
            </HeaderAction>
            <InxToolTip className='ril__tooltip' id={`ril__ttip${idx}`} />
        </AttachDataProvider>;
});

export default rotateFunc => {
    const
        { isApiEnabled, i18n } = useContext(AttachsParamsContext),
        { clickedItemData, currentViewMode } = useContext(AttachsStateContext),
        toolbarButtons = defaultButtons(rotateFunc, i18n.rotateImage);

    if (isApiEnabled('files')) {
        toolbarButtons.push({ action: SAVE_TO_FILES, icon: <i className='ico-product prod-files' /> });
    }

    if (isApiEnabled('foto')) {
        toolbarButtons.push({ action: SAVE_TO_FOTO, icon: <i className='ico-product prod-foto' /> });
    }

    if (currentViewMode === VIEW_MODE.INLINE) {
        toolbarButtons.push({ action: VIEW_AS_GRID, icon: <FaIcon name="FaTh" /> });
    }

    return withItemData(clickedItemData, toolbarButtons);
};
